import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import UserModel from "../../model/UserModel";

export class PageAdminAuthStore {
    private rootStore: RootStore | undefined;

    public arUsers = [];

    public search = '';

    public error: string = '';

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init = () => {
        this.arUsers = [];

        this.reload();
        // @ts-ignore
        this.rootStore?.pageRegEmployeeStore.falseRedirect();
        // @ts-ignore
        this.rootStore?.pageRegTradePointStore.falseRedirect();
    }

    @action
    reload() {
        UserModel.getAdminAll(this.setData, this.setError);
    }

    @action
    setData = (result: any) => {
        result.data.row.map((item: any) => {
            item.updatedAt = new Date(item.updatedAt);
            return item;
        });
        this.arUsers = result.data.row;
    }

    @action setError = (error: any) => {
        console.log(error);
        // this.error = error.response.data.message;
    }

    @action onFilterUser = (e: any) => {
        this.search = e.target.value;
    }

}
